import dashboard from './dashboard';
import management from './management';
// import utilities from './utilities';
// import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    // dashboard, 
    management, 
    // utilities, 
    // other
  ]
};

export default menuItems;
